import { render, staticRenderFns } from "./CampusDevices.vue?vue&type=template&id=747b3bed&scoped=true&"
import script from "./CampusDevices.vue?vue&type=script&lang=ts&"
export * from "./CampusDevices.vue?vue&type=script&lang=ts&"
import style0 from "./CampusDevices.vue?vue&type=style&index=0&id=747b3bed&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747b3bed",
  null
  
)

export default component.exports